// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2okB-","inner":"Footer_inner__3fxyl","nextIcon":"Footer_nextIcon__1D8_w","innerLeft":"Footer_innerLeft__Efm2v"};